import React, { useEffect } from 'react';
import { motion, useSpring, useMotionValue, useReducedMotion } from 'framer-motion';

const MouseGlow = () => {
    const shouldReduceMotion = useReducedMotion();
    const mouseX = useMotionValue(0);
    const mouseY = useMotionValue(0);

    // Spring physics for smooth following
    const springConfig = { damping: 25, stiffness: 150 };
    const x = useSpring(mouseX, springConfig);
    const y = useSpring(mouseY, springConfig);

    useEffect(() => {
        if (shouldReduceMotion) return;
        
        let rafId;
        const handleMouseMove = (e) => {
            if (rafId) cancelAnimationFrame(rafId);
            rafId = requestAnimationFrame(() => {
                mouseX.set(e.clientX - 150); // Offset half of glow size
                mouseY.set(e.clientY - 150);
            });
        };
        window.addEventListener('mousemove', handleMouseMove, { passive: true });
        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            if (rafId) cancelAnimationFrame(rafId);
        };
    }, [mouseX, mouseY, shouldReduceMotion]);

    if (shouldReduceMotion) return null;

    return (
        <motion.div
            className="fixed top-0 left-0 w-[300px] h-[300px] pointer-events-none z-[9999] opacity-0 group-hover:opacity-100 transition-opacity duration-500"
            style={{
                x,
                y,
                background: 'radial-gradient(circle, rgba(255,255,255,0.15) 0%, rgba(255,255,255,0) 70%)',
                mixBlendMode: 'screen',
                filter: 'blur(30px)',
            }}
        />
    );
};

export default MouseGlow;
